<template>
  <section class="media flex flex-col gap-4">
    <review-us v-if="isReviewUsEnabled" />
    <slot name="before"></slot>
    <section class="media-list">
      <a
        v-for="channel in channels"
        :key="channel.name"
        :class="channel.class"
        class="channel font-bold"
        :href="channel.url"
        target="_blank"
        rel="noopener noreferrer"
        @click="handleClickChannel(channel.name)"
      >
        <img v-if="channel.imgSrc" width="16" :src="channel.imgSrc">
        <span>{{ $i18nPresenter.t(channel.name) }}</span>
      </a>
    </section>
    <slot name="after"></slot>
  </section>
</template>
<script>
import { mapGetters } from 'vuex'
import ReviewUs from './ReviewUs.vue'

export default {
  components: { ReviewUs },
  props: {
    channels: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('featureToggles', ['isFeatureEnabled']),
    isReviewUsEnabled() {
      return this.isFeatureEnabled('release-36681-review-us')
    },
  },
  methods: {
    handleClickChannel(name) {
      this.$emit('click-channel', name)
    },
  },
}
</script>
<style lang="scss" scoped>
    .media {
        @apply rounded-lg shadow-card;
        background-color: white;
        padding: 1rem;

        & > .media-list {
            display: flex;
            gap: 0.5rem;
            flex-wrap: wrap;
            justify-content: left;

            & > * {
              color: black;

              &:hover {
                @apply text-primary-90;
              }
            }

            & > * {
              padding: 4px 8px;
              background-color: white;
              border: 1px solid #D3D7E1;
              border-radius: 1000px;
              display: flex;
              align-items: center;
              gap: 4px;

            }
        }
    }
</style>
